import { atom } from 'jotai';
export const $DeploymentVDC = atom(undefined);
$DeploymentVDC.debugLabel = '$DeploymentVDC';
